import { AccountLink } from '@sparkplug/lib';

import LinkLabel from '@features/account-links/components/LinkLabel';

import { useApp } from '@hooks/AppHooks';

const AccountLinkLabel = ({ accountLink }: { accountLink: AccountLink }) => {
    const { appIsMobile } = useApp();
    const isVendorLink = accountLink.accountType === 'brand';
    const locationCount = (accountLink.locations || []).length;
    const brandCount = (accountLink.brandLinks || []).length;

    return (
        <div className="account-link-label" data-testid="account-link-label">
            <LinkLabel
                variant={appIsMobile ? 'base' : 'large'}
                imageUrl={accountLink.photo}
                title={accountLink.accountName}
                accountType={accountLink.accountType}
                subtitle={
                    isVendorLink ? (
                        <div>{`${brandCount} ${brandCount === 1 ? 'Brand' : 'Brands'}`}</div>
                    ) : (
                        <>
                            <div className="account-link-label-locations">
                                {`${locationCount} ${
                                    locationCount === 1 ? 'Location' : 'Locations'
                                }`}
                            </div>
                            <div>{accountLink.markets.join(',')}</div>
                        </>
                    )
                }
            />
        </div>
    );
};

export default AccountLinkLabel;
